import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { TableListPermissionComponent } from '../../../shared/components/table-list-permission/table-list-permission.component'
import {
  ProfileModel,
  SearchProfileModel,
} from '../../../core/models/profile.model'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { PermissionService } from '../../../core/services/permission/permission.service'
import { MatProgressBar } from '@angular/material/progress-bar'

interface PermissionResponse {
  status: string
  perfil_id: number
  total_modulos: number
  data: any[]
}

@Component({
  selector: 'assign-permission',
  imports: [ReactiveFormsModule, TableListPermissionComponent, MatProgressBar],
  templateUrl: './assign-permission.component.html',
  styleUrl: './assign-permission.component.scss',
})
export class AssignPermissionComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private permissionService: PermissionService,
  ) {}

  @Input() profile: ProfileModel = new ProfileModel()

  loading: boolean = true
  formSearch: FormGroup = new FormGroup({})
  page: number = 1
  rows: number = 20
  numberRows: number = 0
  itemsList: any[] = []
  searchForm: SearchProfileModel = new SearchProfileModel()
  columns: any[] = []

  ngOnInit() {
    this.getPermissionbyProfile()
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      search: [''],
    })
  }

  search() {
    let search = this.formSearch.get('search')?.value
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.descricao) {
      this.searchProfile()
    } else {
      this.getPermissionbyProfile()
    }
  }

  pageChanged(page: number) {
    this.page = page
    if (this.searchForm.descricao) {
      this.searchProfile()
    } else {
      this.getPermissionbyProfile()
    }
  }

  getPermissionbyProfile() {
    if (this.profile.id) {
      this.loading = true
      this.permissionService
        .listPagedPermissionProfile(this.page, this.rows, this.profile.id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            // O JSON retorna os módulos diretamente no array 'data'
            this.itemsList = response.data || []
            this.numberRows = response.data.total_modulos || 0
          },
          error: (err: ResponseRequestModel) => {
            console.error('Erro ao carregar permissões:', err)
            this.itemsList = []
            this.numberRows = 0
          },
          complete: () => {
            this.loading = false
          },
        })
    }
  }

  searchProfile() {
    if (this.profile.id) {
      this.searchForm = new SearchProfileModel()
      this.loading = true
      this.permissionService
        .searchPagedPermissionProfile(this.page, this.rows, this.searchForm)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            this.itemsList = response.data || []
            this.numberRows = response.data.total_modulos || 0
          },
          error: (err: ResponseRequestModel) => {
            console.error('Erro ao pesquisar permissões:', err)
            this.itemsList = []
            this.numberRows = 0
          },
          complete: () => {
            this.loading = false
          },
        })
    }
  }
}
